
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { BoardIVO, BoardOVO } from '@/views/biz/board/vo/BoardVO'
import { CommonCodeIVO, CommonCodeOVO } from '@/views/bizcommon/code/vo/CodeVO.vo'
import Constants from '@/constants'
import axios from 'axios'
import InfiniteLoading, { InfiniteOptions } from 'vue-infinite-loading'

@Component({
  components: {InfiniteLoading}
})
export default class BasicBoard extends Vue {
  @Prop() tabCode !: string;
  boards: Array<BoardOVO> = [];
  pageVO: BoardIVO = {} as BoardIVO;

  boardDetail(bmNo: string): void {
    this.$router.push({name: 'BoardDetail', params: {bmNo}})
  }

  getBoards(): void {
    if(this.tabCode) {
      this.pageVO.tabCode = this.tabCode;
    }

    axios.get('/board/boards', {params: this.pageVO})
    .then(r => {
      this.boards = r.data;
      this.pageVO.startNum += Constants.BOARD_PAGE_NUMBER;
    })
  }

  infiniteHandler($state): void {
    axios.get('/board/boards', {params: this.pageVO})
    .then(r => {
      if(r.data.length) {
        this.boards = this.boards.concat(r.data);
        $state.loaded();
      } else {
        $state.complete();
      }
      this.pageVO.startNum += Constants.BOARD_PAGE_NUMBER;
    }).catch(() => {
      $state.complete();
    })
  }

  @Watch('tabCode', {immediate: true})
  changeTab(e): void {
    if(!e) {
      return;
    }
    // 페이징 초기화
    this.pageVO.startNum = 0;
    this.getBoards();

    (this.$refs.infiniteLoading as InfiniteLoading) && (this.$refs.infiniteLoading as InfiniteLoading).stateChanger.reset();
  }
}
